import { SUCCESS_CODE } from '@/constants'
import { MockMethod } from 'vite-plugin-mock'

const timeout = 1000

export default [
  {
    url: '/mock/dataCenter/list',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: [
          20,
          300,
          1500, // 今日、本周、本月订单
          15,
          250,
          1200, // 昨日、上周、上月订单
          5,
          7,
          3,
          6, // 待接单，待发货，库存不足
          2000.0,
          10000.0,
          50000.0, // 今日、本周、本月收入
          1500.0,
          8000.0,
          40000.0, // 昨日、上周、上月收入
          150,
          900 // 在售商品，总商品数
        ]
      }
    }
  }
] as MockMethod[]
